<template>
  <section :class="{ 'opacity-50': disabled }" class="relative mb-4">
    <DateSelectorCard
      ref="dateSelector"
      v-model:selected-date="selectedDateEvent"
      :value="eventDateSelectors"
      :value-per-month="eventDateSelectorsPerMonth"
      :current-date="currentEventMapped"
      :active-dates="eventDateSelectors"
      :loading="loading"
      :helpers="helpers"
      :show-title="showTitleWithSlider"
      :is-helper-filter="true"
      @update:selected-date="onUpdateSelectedDate"
      @popstate-change="popStateHandler"
      @disable-prev-btn="disablePrevBtn = $event"
      @disable-next-btn="disableNextBtn = $event"
    >
      <template #title>
        <UiTitle v-ui-test-name="'dateSelectorTitle'" class="!px-0" tag="h3">
          Расписание
        </UiTitle>
      </template>
    </DateSelectorCard>
  </section>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type {
  Event,
  DateSelectorWithTimes,
  ChangeDatePayload,
  DateSelectorHelper,
} from '~/models'
import { useWidgetEnvironment } from '~/widget/composables/useWidgetEnvironment'

const props = defineProps({
  disabled: {
    type: Boolean,
    required: true,
  },
  currentEvent: {
    type: Object as PropType<Event>,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  helpers: {
    type: Array as PropType<DateSelectorHelper[]>,
    required: false,
    default: () => [],
  },
})

const emit = defineEmits<{
  (e: 'eventSelect', value: ChangeDatePayload): void
}>()

const selectedDateEvent = ref<DateSelectorWithTimes>()

const { eventDateSelectors, eventDateSelectorsPerMonth } = storeToRefs(
  useEventDateSelector(),
)
const { lastRoute } = storeToRefs(useEventPageKitStore())
const { getDiscountPromo } = usePromo()
const { isWidget } = useRuntimeConfig().public
const { widgetConfiguration } = useWidgetEnvironment()

const disablePrevBtn = ref<boolean>(true)
const disableNextBtn = ref<boolean>(false)
const dateSelector = ref<any>(null)

const goToActiveSlide = () => {
  dateSelector.value!.goToActiveSlide()
}

const currentEventMapped = computed((): DateSelectorWithTimes => {
  const value: DateSelectorWithTimes = { ...props.currentEvent }
  const isPromo =
    props.currentEvent?.promo && !!getDiscountPromo(props.currentEvent.promo)

  value.times = []
  value.active = true
  value.isPromo = isWidget
    ? widgetConfiguration.value?.isPromotionsEnabled && isPromo
    : isPromo

  return value
})

const onUpdateSelectedDate = (
  _value?:
    | DateSelectorWithTimes
    | [DateSelectorWithTimes, DateSelectorWithTimes],
  openOrderMobile?: boolean,
) => {
  if (props.disabled) return

  emit('eventSelect', {
    event: {
      id: selectedDateEvent.value?.id,
      beginsAt: selectedDateEvent.value?.beginsAt,
      urlSlug: selectedDateEvent.value?.urlSlug || '',
    },
    openOrderMobile,
  })
}

// /**
//  * обрабатыват смену роута по кнопкам назад-вперед
//  */
const popStateHandler = () => {
  const { path: currentRoute, hash } = useRoute()
  const eventId = prefixRemover(hash, '#')

  if (currentRoute === lastRoute.value) {
    emit('eventSelect', {
      event: { id: eventId || undefined, urlSlug: currentRoute },
      dontPushInHistory: true,
    })
  }
}

const DATES_COUNT_TO_SLIDER = 5
const showTitleWithSlider = computed(
  () => eventDateSelectors.value.length >= DATES_COUNT_TO_SLIDER,
)

watch(
  () => props.currentEvent,
  (value) => {
    if (value) {
      goToActiveSlide()
    }
  },
)
</script>
